import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../../business/referential/UserContext';
import parse from "html-react-parser";


function CopyrightReceipt({ Callback }) {

    const [isResponseReady, setResponseReady] = useState(false);
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const [pageId, setPageId] = useState(33);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });

        }
        process();

    }, []);

    useEffect(() => {
        if (Callback) {
            setResponseReady(true);
        }
    }, [Callback]);

    const DepositState = () => {
        if (Callback && Callback.deposit) {
            if (Callback.deposit.type_Depot === "JEUX")
                return getContent("CRR_GAME");

            if (Callback.deposit.type_Depot === "MAIL")
                return getContent("CRR_EMAIL");
        }
        return getContent("CRR_DEFAULT");
    }

    const EncryptedData = () => {
        if (Callback && Callback.deposit) {
            if (Callback.deposit.encryptedData.length > 1500)
                return Callback.deposit.encryptedData.substring(0, 1499);

            return Callback.deposit.encryptedData;
        }
        return "";
    }

    return (<> { userData &&
        <div className="dashboard-container">
            <h3 className="mb-2" >
                {getContent("LblTitle")}
            </h3>
            <p className="mb-5">{getContent("CRR_SubTitle")}</p>
            <div className="row mb-4">
                <div className="col-12 col-xl-9">
                    {isResponseReady &&
                        <table className="table table-borderless table-receipt-of-electronic">
                            <tbody>
                                <tr>
                                    <th scope="row">{getContent("LblDateTitle")}</th>
                                    <td>{Callback.deposit.date}</td>
                                </tr>
                                <tr>
                                    <th scope="row">{getContent("CreationTitle")}</th>
                                    <td>{Callback.deposit.title}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Owner:</th>
                                    <td>{parse(Callback.coord)}</td>
                                </tr>
                                <tr>
                                    <th scope="row">{getContent("DepositFileNameTitle")}</th>
                                    <td>{Callback.deposit.depotfilename}</td>
                                </tr>
                                <tr>
                                    <th scope="row">{getContent("LblMd5Title")}</th>
                                    <td>{Callback.deposit.md5}</td>
                                </tr>
                                <tr>
                                    <th scope="row">SHA256:</th>
                                    <td>{Callback.deposit.sha256_Base64}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Copyright Blockchain:</th>
                                    <td>{getContent("CRR_BLOCKCHAIN")}</td>
                                </tr>
                                <tr>
                                    <th scope="row">{getContent("LblStatusTitle")}</th>
                                    <td>
                                        {DepositState()}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">{getContent("LblDescriptionTitle")}</th>
                                    <td>{Callback.deposit.description}.</td>
                                </tr>
                            </tbody>
                        </table>
                    }
                </div>
                <div className="col-12 col-xl-3">
                    <div className="badge-container">
                        <img src="./assets/img/badge.png" alt="badge" className="img-fluid" />
                    </div>
                </div>
                <div className="algorithms-info-container bg-gray">
                    <h5>{getContent("CRR_SECALGO")}</h5>
                    <p><span>{getContent("CRR_HASHING")}</span> <span>MD5</span></p>
                    <p><span>{getContent("CRR_SIGNATURE")}</span> <span>SHA256</span></p>
                    <p><span>{getContent("CRR_FILE")}</span></p>
                </div>
                <form className="dashboard-form">
                    <div className="mb-3">
                        <label className="form-label">
                            {getContent("LblCryptTitle")}
                        </label>
                        <p className="text-break text-start form-control" style={{ height: "auto" }}>
                            {EncryptedData()}
                        </p>
                    </div>
                    <a href="/dashboard" className="btn btn-blue mb-4">
                        {getContent("BtnRegister")}
                    </a>
                </form>
                <a href="/dashboard" className="arrow-back"></a>
            </div>
        </div>} </>);

}

export default CopyrightReceipt;